var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGridView = function SvgGridView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1C2243",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0c.55228475 0 1 .44771525 1 1v6c0 .55228475-.44771525 1-1 1H1c-.55228475 0-1-.44771525-1-1V1c0-.55228475.44771525-1 1-1h6zm-.4 1.4H1.4v5.2h5.2V1.4zM16 0c.5522847 0 1 .44771525 1 1v6c0 .55228475-.4477153 1-1 1h-6c-.55228475 0-1-.44771525-1-1V1c0-.55228475.44771525-1 1-1h6zm-.4 1.4h-5.2v5.2h5.2V1.4zM7 9c.55228475 0 1 .44771525 1 1v6c0 .5522847-.44771525 1-1 1H1c-.55228475 0-1-.4477153-1-1v-6c0-.55228475.44771525-1 1-1h6zm-.4 1.4H1.4v5.2h5.2v-5.2zM16 9c.5522847 0 1 .44771525 1 1v6c0 .5522847-.4477153 1-1 1h-6c-.55228475 0-1-.4477153-1-1v-6c0-.55228475.44771525-1 1-1h6zm-.4 1.4h-5.2v5.2h5.2v-5.2z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGridView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grid_view.580f3d12.svg";
export { ForwardRef as ReactComponent };